const surveys = state => state.surveys

export default {
  surveys
}



// WEBPACK FOOTER //
// ./src/store/modules/productData/getters.js